var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"claimConfirmationModal",attrs:{"id":"claimConfirmationModal","hide-footer":"","hide-header":"","size":"xl"}},[_c('div',{staticClass:"modal-container"},[_vm._v(" "+_vm._s((_vm.numberOfSelected + " Added"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }